import ILoanDrawdownCondition from './ILoanDrawdownCondition';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function transformLoanDrawdownCondition(loanDrawdownCondition: ILoanDrawdownCondition): any {
    return {
        name: loanDrawdownCondition.name,
    };
}

